//=require jquery.min.js
//=require html5shiv.min.js
//=require respond.min.js
//=require ../../../../../node_modules/bootstrap/dist/js/bootstrap.min.js
//=require ../../../../../node_modules/scrollreveal/dist/scrollreveal.min.js
//=require ../../../../../node_modules/jquery.localscroll/jquery.localScroll.min.js
//=require ../../../../../node_modules/jquery.scrollto/jquery.scrollTo.min.js
//=require parallax.js
//=require ../../../../../node_modules/owl.carousel/dist/owl.carousel.js
//=require ../../../../../node_modules/jquery-mask-plugin/dist/jquery.mask.min.js

$('#boxLinks').localScroll({
                               target: 'body'
                           });

$('.telefone').mask('(00)00000-0000');
$('#data').mask('00/00/0000');

$('.owl-carousel').owlCarousel({
                                   loop: true,
                                   nav: false,
                                   items: 1,
                                   autoplay: true
                               });

$(window).on('scroll', function () {
    if ($(window).scrollTop() > 170) {
        $("header").addClass('ativo');
    } else if ($(window).scrollTop() < 170) {
        $("header").removeClass('ativo');
    }
});

$('.botaoresponsivo').click(function () {
    $('.fullmenu').toggleClass('menumobile');
    $('.linhasmr').toggleClass('ativo');
    if ($('.linhasmr').hasClass('ativo')) {
        $(".linhasmr").addClass("ativo");
        $(".nav-collapse").addClass("in");
        $(".collapse").css({
                               height: 'auto'
                           });
    } else {
        $(".linhasmr").removeClass("ativo");
        $(".nav-collapse").removeClass("in");
        $(".collapse").css({
                               height: '0'
                           });
    }

    if ($('.fullmenu').hasClass('menumobile')) {
        $(".fullmenu").addClass("menumobile");
    } else {
        $(".fullmenu").removeClass("menumobile");
    }

    return false;
});

$('.fullmenu a').click(function () {
    $(".fullmenu").removeClass("menumobile");
    $(".linhasmr").removeClass("ativo");
    $(".nav-collapse").removeClass("in");
    $(".collapse").css({
                           height: '0'
                       });
});

//if ($(window).width() > 1024) {
window.sr = ScrollReveal({
                             reset: true,
                             mobile: false
                         });
var fromtop = {
    origin: "top",
    distance: "200px",
    duration: 1500,
    scale: 0
};
var fromleft = {
    origin: "left",
    distance: "50%",
    duration: 1500,
    scale: 0,
    opacity: 1
};
var fromleft2 = {
    origin: "left",
    distance: "50%",
    duration: 2000,
    scale: 0,
    opacity: 1
};
var frombottom = {
    origin: "bottom",
    distance: "70%",
    duration: 2000,
    scale: 0
};
var fromright = {
    origin: "right",
    distance: "50%",
    duration: 1500,
    scale: 0,
    opacity: 1
};
var fromright2 = {
    origin: "right",
    distance: "50%",
    duration: 2000,
    scale: 0,
    opacity: 1
};

//GERAL REVEAL

sr.reveal('.owl-carousel', {
    duration: 1000,
    scale: 0.3
}, 80);
sr.reveal('.parceiros img', {duration: 1000}, 80);
sr.reveal('.sobre p', fromleft);
sr.reveal('.sobre img', fromright);
sr.reveal('.servicos .servico', {
    duration: 1000,
    scale: 0.5
}, 80);

//}

/****************************** FUNCAO TESTA EMAIL **********************/

function IsEmail(email) {
    var exclude = /[^@\-\.\w]|^[_@\.\-]|[\._\-]{2}|[@\.]{2}|(@)[^@]*\1/;
    var check = /@[\w\-]+\./;
    var checkend = /\.[a-zA-Z]{2,3}$/;
    if (((email.search(exclude) != -1) || (email.search(check)) == -1) || (email.search(checkend) == -1)) {
        return false;
    } else {
        return true;
    }
}

/****************************** ENVIA FORM CONTATO **********************/

$("#formContato").submit(function (e) {
    e.preventDefault();

    $('#btnEnviarContato').html('<i class="fa fa-spinner fa-spin"></i> Aguarde. Enviando.');

    var nome = $("#nome").val();
    var email = $("#email").val();
    var telefone = $("#telefone").val();
    var mensagem = $("#mensagem").val();
    var erros = 0;

    if (nome == '') {
        $("#nome").addClass('errorField');
        erros++;
    } else {
        $("#nome").removeClass('errorField');
    }
    if (email == '' || !IsEmail(email)) {
        $("#email").addClass('errorField');
        erros++;
    } else {
        $("#email").removeClass('errorField');
    }
    if (telefone == '') {
        $("#telefone").addClass('errorField');
        erros++;
    } else {
        $("#telefone").removeClass('errorField');
    }
    if (mensagem == '') {
        $("#mensagem").addClass('errorField');
        erros++;
    } else {
        $("#mensagem").removeClass('errorField');
    }

    if (erros == 0) {

        $.post(url + '/email/form_contato.php', $("#formContato").serialize(), function (data) {
            if (data == '1') {
                $(".erroContato").fadeOut('slow');
                $("#formContato")[0].reset();
                $(".sucessoContato").fadeIn('slow');
                $('#btnEnviarContato').html('Enviar');
            }
        });
    } else {
        $(".erroContato").fadeIn('slow');
        $('#btnEnviarContato').html('Enviar');
    }
});

$('.abreModal').on('click', function (e) {
    e.preventDefault();
    var modal = $(this).data('modal');
    $('html').addClass('cutScroll');
    $("header").removeClass('ativo');
    $('#modal' + modal).fadeIn();
});

$('.modal .table').on('click', function (e) {
    //e.preventDefault();
    var target = $(e.target);
    if (target.is('#modalBody') || target.parents().is('#modalBody')) return;
    $('html').removeClass('cutScroll');
    $("header").addClass('ativo');
    $('.modal').fadeOut();

});

$('.modal').on('click', '.close', function (e) {
    //e.preventDefault();
    $('html').removeClass('cutScroll');
    $('.modal').fadeOut();
});

$("[placeholder]").focus(function() {
    var input = $(this);
    if (input.val() == input.attr("placeholder")) {
        input.val("''");
        input.removeClass("placeholder");
    }
}).blur(function() {
    var input = $(this);
    if (input.val() == "''" || input.val() == input.attr("placeholder")) {
        input.addClass("placeholder");
        input.val(input.attr("placeholder"));
    }
}).blur();


// Mapa Google
function initialize() {
    var myOptions   = {
            zoom: 16,
            center: new google.maps.LatLng(-30.0033995,-51.2003096),
            mapTypeId: google.maps.MapTypeId.ROADMAP
        },
        map         = new google.maps.Map(document.getElementById("map_canvas"), myOptions),
        image       = url + 'wp-content/themes/aadvance2017/assets/imgs/contato/marcador.png',
        myLatLng    = new google.maps.LatLng(-30.0033995,-51.2003096),
        beachMarker = new google.maps.Marker({
                                                 position: myLatLng,
                                                 map: map,
                                                 icon: image
                                             });
}

window.onload = initialize;


$(".btnAbreNegociacao").on('click', function (e) {
    e.preventDefault();
    // var str = $("#data").val();
    // var res = str.replace("/", "");
    // var res2 = res.replace("/", "");
    // $("#data").val(res2);
    $('#formNegociacao').submit();
});